import { type FC } from 'react'
import { Spinner } from '../spinner.tsx'
import * as styles from './analysis-transition-overlay.css.ts'

export type AnalysisTransitionOverlayProps = {
  /**
   * Message to display on the overlay (e.g., "Rendering Triage result")
   */
  message: string

  /**
   * Optional aria-label for accessibility
   */
  ariaLabel?: string
}

/**
 * Transition overlay that displays over the activity feed for 2 seconds between analysis
 * completion and result display. Shows a loading spinner with message.
 */
export const AnalysisTransitionOverlay: FC<AnalysisTransitionOverlayProps> = ({
  message,
  ariaLabel = 'Analysis confirmation',
}) => {
  return (
    <div className={styles.overlay} role="status" aria-label={ariaLabel}>
      <div className={styles.content}>
        <Spinner size="128" label={message} variant="cool" />
        <span className={styles.message}>{message}</span>
      </div>
    </div>
  )
}
